import React, { useEffect, useRef } from "react"
import lottie from "lottie-web"
import confettiAnimation from "../../images/form-submit-animation.json"
// import RobotAnimation from "../../images/RobotAnimation.json"
import "./lottie-animations.css"

function LottieAnimation({ animationData, className, animationPath }) {
  const animationRef = useRef()
  let anim,
    anim2 = null
  useEffect(() => {
    anim = lottie.loadAnimation({
      container: animationRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
      path: animationPath,
    })
    // anim2 = lottie.loadAnimation({
    //   container: document.getElementById("Robot-Animation"),
    //   renderer: 'svg',
    //   loop: false,
    //   autoplay: true,
    //   animationData: RobotAnimation,
    // })
    // setTimeout(() => {
    //     anim.destroy()
    //   }, 3000)
    // setTimeout(()=>{
    //     anim2.destroy()
    // },5300)

    return () => {
      anim.destroy()
      // anim2.destroy();
    }
  }, [])

  return <div ref={animationRef} className={className} />
}

export default LottieAnimation
